// Configurable tooltip copy — replace freely, no code changes elsewhere required.
export const ABSOLUTE_DELAY_TIMELINE_INFO_TEXT =
  "Diese Kachel zeigt den absoluten Verzug in Tagen (Soll-Termin bis Ist-Termin) im " +
  "Zeitverlauf. Pro Tag fließen zwei Gruppen ein: aktuell noch offene, bereits überfällige " +
  "Aufträge (mit ihrem bisherigen Verzug bis heute) sowie an diesem Tag abgeschlossene " +
  "Aufträge (mit ihrem finalen Verzug bei Abschluss). Je nach Einstellung werden dabei nur " +
  "verspätete oder alle Aufträge berücksichtigt — bei \"Alle\" zählen pünktliche Aufträge mit " +
  "0 Tagen Verzug. Da einzelne Tage oft nur wenige Fälle haben, wird zusätzlich zur rohen " +
  "Tageslinie eine geglättete Linie über ein gleitendes Zeitfenster gezeigt — die Fallzahl " +
  "dieses Fensters steht im Tooltip des Diagramms.";
